"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _reactSelect = require("react-select");
/** @jsxRuntime classic */
/** @jsx jsx */

const ValueContainer = props => {
  return (0, _core.jsx)(_reactSelect.components.ValueContainer, (0, _extends2.default)({}, props, {
    css: (0, _core.css)`
                // Need to ensure that we show as much of the SingleValue component as possible.
                align-self: stretch;
                padding-left: 0;
            `
  }), props.children);
};
exports.ValueContainer = ValueContainer;
//# sourceMappingURL=ValueContainer.js.map